import React, { useState, useEffect } from "react";
// import "./CreateUserModal.css";
import * as Yup from "yup";
import Form from "../../form/components/Form/Form";
import FormField from "../../form/components/FormField/FormField";
import Button from "../../form/components/Button/Button";
import ErrorMessage from "../../form/components/ErrorMessage/ErrorMessage";
import { ImCancelCircle } from "react-icons/im";
import { toast } from "react-toastify";
import BeatLoader from "react-spinners/BeatLoader";
// import { createCourseContent } from '../../../services/courseContent';
import { registerUser } from "../../../services/auth";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";


import {
  getAuth,
  updateProfile,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { collection, addDoc, getDocs, setDoc, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/firebase-config";
import TextInput from "../../form/Textinput";
import { registerNewDoc } from "../../../services/medAuth";



const override = {
  marginTop: "20px",
};

function UpdateDoctorModal({ onClose, onContentAdded, activeData }: any) {
  
  const [error, setError] = useState<any>(null);
  const [selectedSpeciality, setSelectedSpeciality] = useState("");
  const [displayName, setDisplayName] = useState(null);
  const [loading, setLoading] = useState(false);

  const [allSpecialities, setAllSpeciialities] = useState([]);
  const [activeSpeciality, setActiveSpeciality] = useState("");

  const [initialValues, setInitialValues] = useState({
    displayName: activeData?.username
  });

  const validationSchema = Yup.object().shape({
  });

  const handleAddUser = async (values: any) => {
    setError(null);
  
    let email = values.email;
    let password = values.password;
  
    setLoading(true);
  
    try {
      let reqData = { email, password, displayName, selectedSpeciality };

      const response = await registerNewDoc(reqData);
  
      if (response.ok) {
        toast.success('User Created', {
          pauseOnHover: false,
          closeOnClick: true,
        });
        setLoading(false);
        onContentAdded();
      } else {
        console.log('RES: ', response)
        toast.error("An error occurred while creating user", {
          pauseOnHover: false,
          closeOnClick: true,
        });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error creating user: ", error);
      toast.error("An error occurred while creating user", {
        pauseOnHover: false,
        closeOnClick: true,
      });
      setLoading(false);
    }
  };


  const handleUpdateDoctor = async (values: any) => {
      console.log('VAL: ', values);
      // console.log(values.displayName);
      // console.log(selectedSpeciality);
      // console.log(activeData);

      try {
        const speciality = selectedSpeciality === 'lab' ? 'Lab Technician' : selectedSpeciality === 'pt' ? 'Pathology' : selectedSpeciality === 'admin' ? 'Admin' : selectedSpeciality == 'diabetologist' ? 'Diabetologist' : selectedSpeciality == 'cardiologist' ? 'Cardiologist' : selectedSpeciality;
        setLoading(true);

        let docRef =  doc(collection(db, 'users'), activeData?.id);

        await updateDoc(docRef, {
          username: values.displayName,
          speciality: speciality
        })
        toast.success('User Updated', {
          pauseOnHover: false,
          closeOnClick: true,
        });
        setLoading(false);
        onClose();

      } catch (error) {
        console.log("ERROR");
        toast.error("An error occurred while updating user", {
          pauseOnHover: false,
          closeOnClick: true,
        });
        setLoading(false);
      }
  }

   const fetchSpecialities = async() => {
    let res: any = [];
    const specialities = await getDocs(collection(db, "Specialities"));

      try {

        specialities.forEach((speciality) => {
            res.push({
              id: speciality.id,
              ...speciality.data(),
            });
    
        });

        res.sort((a: any, b: any) => a.speciality_name.localeCompare(b.speciality_name));

        setAllSpeciialities(res);
      } catch (error) {
        
      }
   }

  useEffect(() => {
    fetchSpecialities();
  },[])

  useEffect(() => {
    console.log('DATA: ', activeData)
    if(activeData?.speciality == 'Pathology') {
      setSelectedSpeciality("pt");
    }
    console.log('ALL SPECIALITY: ', allSpecialities);
  },[])

  return (
    <>
    <div>
      <div className="modal-container" id='create-user-modal'>
        <div className="modal-head">
          <p className="modal-title">Update Doctor</p>
          <ImCancelCircle
            style={{ cursor: "pointer" }}
            onClick={onClose}
            size={22}
            color="#fff"
          />
        </div>
        <div className="modal-content">
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <BeatLoader
              color="#3080ED"
              loading={loading}
              cssOverride={override}
            />
          </div>
          <form action="" className="auth-form">
            {error && <ErrorMessage error={error} visible={true} />}
            <Form
              initialValues={initialValues}
              onSubmit={handleUpdateDoctor}
              validationSchema={validationSchema}
            >
            <p className="label-text">Display Name: </p>
              <FormField 
                // onChange={(e:any) => setDisplayName(e.target.value)}
                placeholder="displayname"
                type="text"
                name="displayName"
            />

              {/* <p className="label-text">Email: </p>
              <FormField name="email" type="general" placeholder="Email" /> */}

              {/* <p className="label-text">Password: </p>
              <FormField
                name="password"
                type="general"
                placeholder="Password"
              /> */}

              <p className="label-text">Select Speciality: </p>
              <select
                onChange={(e: any) => setSelectedSpeciality(e.target.value)}
                value={selectedSpeciality}
                className="select-field-modal"
                style={{height: 50}}
              >
                {
                  allSpecialities.map((sp: any) =>  <option value={sp?.speciality_value}>{sp?.speciality_name}</option>)
                }
              </select>

              {!loading && (
                <Button
                  isOutLined={true}
                  isFullWidth={false}
                  title="UPDATE USER"
                />
              )}
            </Form>
          </form>
        </div>
      </div>
      <div className="modal-shadow" onClick={onClose}></div>
    </div>
    {/* <div className="modal-overlay"></div> */}
    </>
  );
}

export default UpdateDoctorModal;
